export interface IWrittenAppointment {
  id: number;
  forDossierRelationIds: number[];
  date?: string;
  time?: string;
  location?: string;
  description?: string;
  createdAt: Date|string;
}

export class WrittenAppointment implements IWrittenAppointment {
  readonly id: number;
  readonly forDossierRelationIds: number[];
  readonly date?: string;
  readonly time?: string;
  readonly location?: string;
  readonly description?: string;
  readonly createdAt: Date;

  constructor({ id, forDossierRelationIds, date, time, location, description, createdAt }: IWrittenAppointment) {
    this.id = id;
    this.forDossierRelationIds = forDossierRelationIds;
    this.date = date;
    this.time = time;
    this.location = location;
    this.description = description;
    this.createdAt = new Date(createdAt);
  }
}
